export enum DropDownValueType {
  String,
  Number,
  Boolean,
}
